import "./offscreen-effects-manager.css";

const SECTION_SELECTOR = [
  "#why",
  "#services",
  "#compliance",
  "#carthy-ai",
  "#sectors",
  "#method",
  "#about",
  "#contact",
].join(",");

function setSectionState(section, awake) {
  section.classList.toggle("is-section-sleeping", !awake);
  section.classList.toggle("is-section-awake", awake);
  section.dataset.carthyPerformance = "section-effects";
  section.dataset.carthyPerformanceState = awake ? "active" : "paused";
}

function installOffscreenEffectsManager() {
  const sections = Array.from(document.querySelectorAll(SECTION_SELECTOR));
  if (!sections.length) return false;

  document.documentElement.dataset.carthyOffscreenManager = "enabled";

  sections.forEach((section) => {
    section.classList.add("section-performance-managed");
    section.dataset.carthyPerformance = "section-effects";
    section.dataset.carthyPerformanceState = "pending";
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const awake = entry.isIntersecting || entry.intersectionRatio > 0;
        setSectionState(entry.target, awake);
      });
    },
    {
      threshold: [0, 0.01],
      // Réveille les effets un peu avant l'arrivée à l'écran pour éviter un pop visuel.
      rootMargin: "220px 0px 220px 0px",
    },
  );

  sections.forEach((section) => observer.observe(section));

  const refreshVisibleStates = () => {
    if (document.hidden) {
      sections.forEach((section) => setSectionState(section, false));
      return;
    }

    const margin = 220;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const awake = rect.bottom >= -margin && rect.top <= viewportHeight + margin;
      setSectionState(section, awake);
    });
  };

  document.addEventListener("visibilitychange", refreshVisibleStates);
  return true;
}

function boot() {
  if (installOffscreenEffectsManager()) return;

  const observer = new MutationObserver(() => {
    if (installOffscreenEffectsManager()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
